import React from 'react';
import { VISUALS } from '../../data/visuals';

export function VisualShowcase() {
  return (
    <section className="section fade-in">
      <div className="section-label">In the World</div>
      <h2>Where TrueNooch™ Lives</h2>
      <div className="visual-showcase">
        {VISUALS.map((v) => (
          <div key={v.src} className="visual-card">
            <img
              src={`${process.env.PUBLIC_URL}${v.src}`}
              alt={v.title}
              loading="lazy"
            />
            <div className="visual-card-body">
              <div className="visual-card-title">{v.title}</div>
              <div className="visual-card-desc">{v.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
